import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { COACH_PLAYER, EMPTY_PLAYER } from '../../utils/helpers.js'


import { GAME_FACT_HANDBALL_REDCARD, reasonListHandballRedCard} from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapHandballRedCard = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, timer, player, reason, period} = state

    const [img] = useGameFact({type : GAME_FACT_HANDBALL_REDCARD})

    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)
    
    let selectedPlayer = player==='coach' ? COACH_PLAYER(teamSelected) : allPlayers.find(p => p._id === player) ?? EMPTY_PLAYER

    const actualPeriod = period ??  match.period

    // Gestion du text
    useEffect(() => {
        if(!state.text || state.edited){
            
            const monText = 'Carton rouge pour '+selectedPlayer.lastname+'! '+(reason && reason!=='autres' ? 'Raison : '+reasonListHandballRedCard.find(r => r.id === reason).value+'.':'')
            
            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'CARTON ROUGE'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    return (
        <div style={{color : inHistory ? 'black' : 'white'}}>
            <img src={img} width={150}/>
            <Typography>Equipe : {teamSelected.name}</Typography>
            <Typography>Joueur : {selectedPlayer.lastname} ({reasonListHandballRedCard.find(r => r.id === reason).value})</Typography>
            {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}

            {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
            {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
        </div>
    )
}

export default RecapHandballRedCard